import {EntityDomainModel} from "../../../../infrastructure/models/entity/entity.domain-model";
import {LanguageApiModel} from "./language.api-model";

export class LanguageDomainModel extends EntityDomainModel {
  apiModel: LanguageApiModel;

  get cultureName(): String {
    return this.apiModel.cultureName.toLowerCase();
  }

  get displayName(): String {
    return this.apiModel.displayName;
  }

  get direction(): String {
    return this.apiModel.direction;
  }

  get didomiCode(): String {
    return this.apiModel.didomiCode
  }

  get hreflang(): Boolean {
    return this.apiModel.hreflang;
  }

  get invalidUserCountryIds(): Array<Number> {
    return this.apiModel.invalidUserCountryIds;
  }
}
